module.exports = __webpack_public_path__ + "img/country-snapshot.766524f.jpg";